import styled from 'styled-components';
import { bordaArredondar, espacamento } from '../../styles/constants/sizes';

export const LinkEmail = styled.a`
  cursor: pointer;
`;

export const JanelaLogin = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 4px;
  padding: ${espacamento.medio}px;
  box-shadow: 0 5px 30px 0 rgb(0 0 0 / 50%);
  display: flex;
  width: 80%;
  max-width: 600px;
  flex-direction: column;

  div {
    max-height: 90vh;
  }

  iframe {
    max-width: 100%;
    max-height: 80vh;
  }

  img {
    object-fit: contain;
    overflow: hidden;
    max-height: 75vh;
  }
`;

export const JanelaLoginTotem = styled.div`
  position: absolute;
  top: 3%;
  left: 50%;
  transform: translate(-50%, 0%);
  background-color: #fff;
  border-radius: 4px;
  padding: ${espacamento.medio}px;
  padding-top: 15px;
  box-shadow: 0 5px 30px 0 rgb(0 0 0 / 50%);
  display: flex;
  width: 80%;
  max-width: 600px;
  flex-direction: column;

  div {
    max-height: 90vh;
  }

  iframe {
    max-width: 100%;
    max-height: 80vh;
  }

  img {
    object-fit: contain;
    overflow: hidden;
    max-height: 75vh;
  }
`;

export const TituloModal = styled.h4`
    font-size: 1.2em;
    border-bottom: 1px solid #dededd;
    padding-bottom: ${espacamento.extraPequeno}px;
    margin-top: 0;
    color: #828282;
`;

export const Aviso = styled.span`
  background-color: #f2f2f2;
  border-radius: ${bordaArredondar}px;
  border: 1px solid #ddd;
  padding: ${espacamento.pequeno}px;
`;

export const ContainerSeletor = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 35px;
  padding-bottom: 10px;

  input {
    width: 22px;
    height: 22px;
    margin: 0;
  }

  label {
    font-size: 24px;
    padding-left: 7px;
  }
`;
